@if (datasets.length > 1 && datasetsInputType === 'tab') {
<div class="d-flex flex-row datasets d-lg-none">
  @for (entry of datasets; track entry) {
<div class="col dataset p-3"
      
       [class.active]="dataset === entry.dataset"
       (click)="changeDataset(entry)"
  >
    {{ entry.label | translate }}
  </div>
}
</div>
}
<mat-sidenav-container class="w-100">
  <mat-sidenav mode="over" #sidenav position="end" [opened]="false" class="sidenav-filter pt-3">
    <div class="w-100 h-100 p-3">
      <div class="close" (click)="sidenav.close()">
        <fa-icon [icon]="icons.falTimes"></fa-icon>
      </div>

      @if (!lockSidenavOpen) {
<app-map-filters [filter]="filter" [filters]="filters" (selectedAreaChange)="searchArea($event)"></app-map-filters>
}
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="container-fluid h-100">
      <div class="row h-100">

        <div class="loader-overlay" [class.shown]="isLoading">
          <fa-icon [icon]="icons.falSpinnerThird" size="3x" animation="spin"></fa-icon>
        </div>

        <div class="d-flex d-lg-none justify-content-end align-items-center chart-controls w-100">
          <button class="btn btn-default" (click)="sidenav.toggle()"
          aria-label="filters">
            <fa-icon [icon]="icons.falFilter" class="mr-1"></fa-icon>
            {{ 'ui.charts.filters' | translate }}
          </button>
        </div>

        @if (lockSidenavOpen) {
<div class="col-lg-3 col-md-12 filters">
          @if (datasets.length > 1 && datasetsInputType === 'tab') {
<div class="row datasets">
            @for (entry of datasets; track entry) {
<div class="col dataset p-3"
                
                 [class.active]="dataset === entry.dataset"
                 (click)="changeDataset(entry)"
            >
              {{ entry.label | translate }}
            </div>
}
          </div>
}

          <div class="breathe">
            @if (datasets.length > 1 && datasetsInputType == 'select') {
<mat-form-field class="w-100" floatLabel="always">
              <mat-label>{{ 'labels.dataset' | translate }}</mat-label>
              <mat-select
                          [ngModel]="datasetEntry"
                          (ngModelChange)="changeDataset($event)">
                @for (entry of datasets; track entry) {
<mat-option [value]="entry">{{entry.label | translate}}</mat-option>
}
              </mat-select>
            </mat-form-field>
}

            <app-map-filters [filter]="filter" [filters]="filters" (selectedAreaChange)="searchArea($event)"></app-map-filters>
          </div>
        </div>
}

        <div class="col-lg-9 col-md-12 chart">
          <div class="row position-relative flex-column">

            <div class="map-container" [class.loading]="isLoading">
              <div #map id="map"></div>

              @if (dataset.legend) {
<app-map-legend [definition]="dataset.legend"></app-map-legend>
}

              @if (details || detailsLoading) {
<div class="details-container">
                @if (details) {
<ul>
                  @for (detail of details; track detail) {
<li>
                    <span class="label">{{ detail.label | label | async }}</span>
                    <span class="value">{{ detail.value }}</span>
                  </li>
}
                </ul>
}
                @if (detailsLoading) {
<fa-icon class="details-loader" [icon]="icons.falSpinnerThird" size="2x" animation="spin"></fa-icon>
}
              </div>
}
            </div>

            @if (showControls) {
<div class="controls-overlay" (click)="closeControls()"></div>
}
            <div class="controls" [class.shown]="showControls">
              <button class="close" (click)="closeControls()">
                <fa-icon [icon]="icons.falTimes"></fa-icon>
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>




